import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Price from "components/Price";
import ImageLoad from 'components/ImageLoad';
import tcencoImage from 'images/home-isla-2-min.png'
import PromotionFactory from 'factories/Promotion';
import style from './style.scss'; //NOSONAR



const ProductPrices = (props) => {
    const productDetail = props.productDetail;
    const [isMobile, setMobile] = useState(false);
    let settings = {
        promotionDescription: false
    }

    useEffect(() => {

        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        return function cleanup() {

            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }
    }, []);

    const checkViewport = () => {
        if (!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 425;

        setMobile(currentIsMobile);
    };

    

    useEffect(() => {
        if (props.settings) {
            Object.assign(settings, props.settings)
        }
    }, []);


    const getPrices = () => {
        const { item, skuData } = props;
        
        if (!item) return [];
        
        let prices = [];
        
        const promotions = PromotionFactory.create(item, skuData);
        
        const isOffer = promotions.filter(promotion => {
            return promotion.type === 'regular' && !promotion.tcenco
        }).length > 0;
        
        let productPrice = item.prices;
        
        if (!productPrice) {
            productPrice = {
                old: 0,
                oldPpum: 0,
                regular: 0,
                regularPpum: 0
            }
        }
        
        let unitMeasurement = '';
        if(item.measurementUnit === 'kg' && item.unitMultiplier < 1){
            unitMeasurement = (item.unitMultiplier * 1000) + ' g';
        } else if(item.measurementUnit === 'kg' && item.unitMultiplier > 1){
            unitMeasurement = (item.unitMultiplier + ' ' + item.measurementUnit);
        } else {
            unitMeasurement = ((item.unitMultiplier || 1) + ' ' + (item.measurementUnit || 'un'));
        }
        
        if (!isOffer && productPrice.old && (productPrice.regular < productPrice.old)) {
            prices.push({
                title: false,
                type: 'regular',
                subtitle: false,
                oldPrice: productPrice.old,
                oldPpum: productPrice.oldPpum,
                price: productPrice.regular,
                pricePpum: productPrice.regularPpum,
                measurementUnit: skuData ? skuData.measurement_unit_un : 0,
                isPriceView: true,
                unitMeasurement: unitMeasurement
            });
        } else {
            prices.push({
                title: false,
                type: '',
                subtitle: false,
                oldPrice: isOffer ? productPrice.old : false,
                price: isOffer ? false : productPrice.regular,
                oldPpum: productPrice.oldPpum,
                pricePpum: isOffer ? productPrice.oldPpum : productPrice.regularPpum,
                measurementUnit: skuData ? skuData.measurement_unit_un : 0,
                isPriceView: true,
                unitMeasurement: unitMeasurement
            });
        }
        
        prices = prices.concat(promotions);
        
        
        
        promotions.map(promotion => {
            if (promotion.tcenco) {
                promotion.description
            }
            
        });
        
        return prices;
    }

    const prices = getPrices();

    if(prices.length === 1){
        const item = prices[0];
        return <div className={'product-single-price' + (productDetail ? ' product-single-pdp' : '')}>
            <div className="product-single-price-container">
                <Price price={item.price} />
                {((item.measurementUnit === 'kg') && !!item.pricePpum && !!item.measurementUnit) ? <span className={'product-price-ppum'}>(<Price price={item.pricePpum}/> x {item.measurementUnit})</span> : ''}
            </div>
        </div>
    }

    return (
        <div className={'prices-product' + (productDetail ? ' pdp' : '')}>
            {prices.map((item, i) => {
                const titlePromo = (item.title && item.isPriceView && (item.title.length < 12)) ? item.title : '';
                const titlePromoIsMoreProducts = (item.title && (item.title.split('%').length > 1)) ? (item.title.split('%')[0] + '% de dcto.') : item.title;
                const subtitleIsMoreProducts = (item.title && (item.title.split('%').length > 1)) ? 'en la '+item.title.split('%')[1] : '';
            
                return <div className={'price-product-item ' + (item.isPromotion ? ' promotion ' : '') + item.type + (item.tcenco ? ' tcenco ' : '') + ((item.isPriceView) ? '' : ' center-content ') + (item.isPriceView && !item.title ? ' price-with-unit ' : '') + ((productDetail) ? ' price-unit-pdp' : '' ) + ((subtitleIsMoreProducts.includes('unid.')) &&  productDetail ? ' promotion-pdp' : '')} key={i}>
                    {item.isPriceView && <div className={'price-product-text'}>
                        {item.oldPrice && <div className={'price-product-old-price' + ((isMobile && !productDetail) ? ' mobile-plp ' : '')}>
                            <span className='price-product-value'><Price price={item.oldPrice} /></span>
                            {(item.measurementUnit === 'kg') && !item.title && !!item.pricePpum && !!item.measurementUnit && <span className="price-product-title-ppum" >(<Price price={item.oldPpum}/> x {item.measurementUnit})</span>}
                        </div>}
                        <div className="price-product-best-wrap">
                            <div className={"price-product-content" + ((isMobile && !productDetail) ? ' mobile-plp ' : '')}>
                                {item.price && <span className={'price-product-best' + (!item.title ? ' highlight ' : '') + (!item.oldPrice ? ' optic-center' : '')}>
                                    {titlePromo && <span className="price-product-prom">{titlePromo}</span>}<Price price={item.price} />
                                </span>}
                                {((item.measurementUnit === 'kg') && !item.oldPrice && item.isPriceView && !!item.pricePpum && !!item.measurementUnit) && <span className={"price-product-title-ppum" + ((isMobile && !productDetail) ? ' mobile-plp ' : '')} >(<Price price={item.pricePpum}/> x {item.measurementUnit})</span>}
                            </div>
                            {item.tcenco && !item.oldPrice && <ImageLoad src={tcencoImage} className="prices-tcenco-logo" alt="Cencosud"/>}
                        </div>
                    </div>}

                    {!item.isPriceView && <div className={'price-product-label' + ((productDetail) ? ' price-mxn-content ' : ' ') + ((subtitleIsMoreProducts.includes('unid.')) ? ' promotion-porcentual-content ' : '') + (item.isPriceView ? ' center-content' : '')}>
                        <span className={'price-product-label-title'}>
                            <div className={"price-product-best-wrap " + ((productDetail && subtitleIsMoreProducts.includes('unid.')) ? ' pdp' : '') }>
                                <div className={"promotion-title-product-best price-promotion-mxn" + (productDetail ? ' promotion-mxn-pdp ' : '') + ((subtitleIsMoreProducts.includes('unid.')) ? ' promotion-porcentual' : '') + ((item.tcenco && productDetail) ? ' tcenco-pdp ' : '') + (!item.tcenco && !productDetail ? ' regular-plp' : '')}>
                                    <span className={'price-product-best price-promotion-mxn ' + (productDetail ? ' promotion-mxn-pdp ' : '')}>{titlePromoIsMoreProducts}</span>
                                    {subtitleIsMoreProducts && <div className={"price-product-subtitle " + (productDetail ? ' pdp' : '')}>{subtitleIsMoreProducts}</div>}
                                </div>
                                {item.tcenco && <ImageLoad src={tcencoImage} className="prices-tcenco-logo" alt="Cencosud"/>}
                            </div>
                            {!item.isMoreProducts && <div className='price-product-label-msg'>*El total de la promoción será aplicado al precio regular.</div>}
                            {item.isMoreProducts && <div className='price-product-label-msg'>*El total de la promoción será aplicado al producto de precio regular más bajo.</div>}
                        </span>
                    </div>}
                </div>
            })}
            {prices.length > 0 && prices.filter(item => !item.isPriceView).filter(Boolean).length > 0 && <div className={'price-product-label-msg plp'}>El total de la promoción será aplicado al precio sin descuento.</div>}
        </div>
    )
}

ProductPrices.propTypes = {
    item: PropTypes.object,
    skuData: PropTypes.object,
    settings: PropTypes.object,
    priceOld: PropTypes.bool,
    productDetail: PropTypes.bool
};

export default ProductPrices;
